import React from "react";
import { CheckCircle2Icon, XCircleIcon } from "lucide-react";
import { afterItems, beforeItems } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function BeforeAfter() {
  return <section className="bg-cream px-4 py-16 sm:py-20" data-id="element-59" data-mp="26ne8fzi6n7c4">
      <div className="mx-auto max-w-5xl" data-id="element-60" data-mp="26k08exwzra7u">
        <h2 className="text-center font-serif text-[2rem] font-extrabold leading-tight text-navy sm:text-5xl" data-id="element-61" data-mp="22lsoxvb57usy">
          Before vs. <span className="italic text-teal" data-id="element-62" data-mp="2zai8dq2f4vh1">with the system</span>
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-63" data-mp="2ud080o2gvokn">
          <div className="rounded-3xl border-2 border-red-200 bg-white p-6 sm:p-8" data-id="element-64" data-mp="2qabva5amtxie">
            <p className="inline-flex rounded-full bg-red-600 px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-65" data-mp="2qc6ijq9dm1pn">Before</p>
            <ul className="mt-6 space-y-4" data-id="element-66" data-mp="1evggmjbzjw1u">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[17px] leading-snug text-ink" data-id="element-67" data-mp="19vkc8izdm2lr">
                  <XCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-red-600" aria-hidden="true" data-id="element-68" data-mp="174uiolbxyx14" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-cta bg-white p-6 shadow-[0_20px_40px_-20px_rgba(22,163,74,0.45)] sm:p-8" data-id="element-69" data-mp="y4xyox0hymce">
            <p className="inline-flex rounded-full bg-cta px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-70" data-mp="132psjwkpcij8">With Master Planner™</p>
            <ul className="mt-6 space-y-4" data-id="element-71" data-mp="t5l2hlnqk2x5">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[17px] font-medium leading-snug text-ink" data-id="element-72" data-mp="t7foz4eno33c">
                  <CheckCircle2Icon className="mt-0.5 h-6 w-6 shrink-0 text-cta" aria-hidden="true" data-id="element-73" data-mp="fcd9bpk0azdc" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <CtaButton label="I want a structured planning system" className="mt-10" data-id="element-74" data-mp="af3o6m3nh9vb" />
      </div>
    </section>;
}